import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'
import { FormattedMessage } from 'react-intl'
import TopicSearchItem from './SearchItem'

export default class Search extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      suggestions: [],
      noSuggestions: false
    }

    this.lastRequestId = null
    this.selectItemBound = this.selectItem.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.searchResults !== nextProps.searchResults &&
      this.state.value.length > 2
    ) {
      this.setState({
        suggestions: nextProps.searchResults,
        noSuggestions: nextProps.searchResults.length === 0
      })
    }
  }

  getSuggestions(value) {
    const inputValue = value.trim().toLowerCase()
    const inputLength = inputValue.length
    return inputLength < 3 ? [] : this.props.searchResults
  }

  getSuggestionValue(suggestion) {
    return suggestion.name
  }

  renderSuggestion(suggestion) {
    return (
      <div>
        <TopicSearchItem topic={suggestion} />
      </div>
    )
  }

  render() {
    const { value, suggestions, noSuggestions } = this.state

    let placeholder = 'Search for the topic or standard by typing its name here'

    const inputProps = {
      placeholder,
      value,
      onChange: this.onChange
    }

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          onSuggestionSelected={this.selectItemBound}
          renderInputComponent={this.renderInputComponent}
        />
        {noSuggestions && value.length > 2 && !this.props.isSearching && (
          <div className="autocomplete-result" id="noMatches">
            <FormattedMessage
              id={'ActivityTopics.Search.NoMatches'}
              defaultMessage={'No matches found'}
            />
          </div>
        )}
      </div>
    )
  }

  renderInputComponent(inputProps) {
    return (
      <div id="topicSearch">
        <div className="search">
          <div className="form-control" id="topicInput">
            <input {...inputProps} />
          </div>
        </div>
      </div>
    )
  }

  onChange = (event, { newValue }) => {
    const noSuggestions = newValue === ''
    this.setState({
      value: newValue,
      noSuggestions: noSuggestions
    })
    if (newValue && newValue.length > 2) {
      this.props.dispatch(this.props.searchItems(newValue))
    }
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.loadSuggestions(value)
  }

  loadSuggestions(value) {
    // Cancel the previous request
    if (this.lastRequestId !== null) {
      clearTimeout(this.lastRequestId)
    }

    this.lastRequestId = setTimeout(() => {
      this.setState({
        suggestions: this.getSuggestions(value)
      })
    }, 1000)
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
      noSuggestions: false
    })
  }

  selectItem(e, { suggestion }) {
    this.props.addItem(suggestion.id)
    this.setState({
      value: '',
      suggestions: [],
      noSuggestions: false
    })
  }
}

Search.propTypes = {
  searchResults: PropTypes.array,
  addItem: PropTypes.func,
  dispatch: PropTypes.func,
  isSearching: PropTypes.bool,
  searchItems: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/topics/Search.js